const guideUrl = {
  pcp: 'https://customer.vwfs.co.uk/car-finance-options/solutions-personal-contract-plan.html',
  hp: 'https://customer.vwfs.co.uk/car-finance-options/hire-purchase.html',
};

const videoUrl = {
  pcp: 'https://www.youtube.com/watch?v=R9K40JVeS1o&ab_channel=VWFSUK',
  hp: 'https://www.youtube.com/watch?v=jPsEulH4LAI&ab_channel=VWFSUK',
};

const financeHelpConfig = {
  uk: {
    showHPGuide: true,
    showPcpGuide: true,
    showPaymentPlanImage: true,
    showPaymentPlanText: true,
    showFinanceUsp: true,
    showDealership: true,
  },
  fr: {
    showHPGuide: false,
    showPcpGuide: false,
    showPaymentPlanImage: false,
    showPaymentPlanText: true,
    showFinanceUsp: false,
    showDealership: true,
  },
  de: {
    showHPGuide: false,
    showPcpGuide: false,
    showPaymentPlanImage: true,
    showPaymentPlanText: true,
    showFinanceUsp: true,
    showDealership: false,
  },
};

export { financeHelpConfig, guideUrl, videoUrl };
